var angular = require('angular');
angular.module('ikeweb.user').controller('LoginController', ['$scope', '$location', 'loginService',
    function login($scope, $location, loginService) {

        if (loginService.getLoggedInUser()) {
            $location.path('gallery');
        }

        $scope.user = {};
        var loginInProgress,
            error;

        function login() {
            $scope.user.username = $scope.user.username.toLowerCase();
            loginInProgress = true;
            error = false;

            return loginService.login($scope.user)
                .then(function() {
                    loginInProgress = false;
                    $location.path('gallery');
                }, function() {
                    loginInProgress = false;
                    error = true;
                });
        }

        this.hasError = function() {
            return error;
        };

        this.inProgress = function() {
            return loginInProgress;
        };

        this.login = login;
        this.loggedIn = loginService.isLoggedIn;
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/login/login.controller.js
// module id = 466
// module chunks = 0